//import SourdoughRoundSrc from "images/sour/sourdough_round2.png";
//import SourdoughSesameSrc from "images/sour/SesameCrustedSourdough.jpg";
//import PandesalSrc from "images/sour/Pandesal.jpg";
import DinnerRollsSrc from "images/sour/DinnerRolls.jpg";
//import StarBreadSrc from "images/sour/StarBread.jpg";
//import TreeBreadSrc from "images/sour/TreeBread.jpg";
import SourdoughUbeSrc from "images/sour/UbeSourdough.jpg";
//import BrowniesSrc from "images/sour/brownies.png";
import CookiesSrc from "images/sour/cookies.png";
//import CheesecakeSrc from "images/sour/cheesecake.png";
import SconesSrc from "images/sour/scones.jpg";
import SconesBlueberrySrc from "images/sour/BlueberryScones.jpg";
import SconesBlueberry5ctSrc from "images/sour/BlueberryScones5ct.jpg";
import Scones5Src from "images/sour/scones5.jpg";
import CinnamonRollsSrc from "images/sour/cinnamon_rolls.png";
import CinnamonRollsWildBerrySrc from "images/sour/BerrySweetRolls.jpg";
import SourdoughOvalSrc from "images/sour/sourdough_oval.jpg";
import BrownButterCrumbleSrc from "images/sour/BrownButterCrumble.jpg";
//import SwedishCinnamonRollsSrc from "images/sour/SwedishCinnamonBuns1.jpg";
//import SourdoughMiniSrc from "images/sour/sourdough_mini.png";
import SourdoughMiniJalapenoCheddarSrc from "images/sour/sourdough_mini_jalapenocheddar.png";
import SourdoughJalapenoCheddarSrc from "images/sour/Sourdough_JalapenoCheddar.jpg";
//import SauerkrautSrc from "images/sour/sauerkraut.png";
import SourdoughFocacciaSrc from "images/sour/GarlicParmesanFocaccia4.jpg";
//import KombuchaSrc from "images/sour/kombucha.png";
import MuffinsSrc from "images/sour/Muffins2.jpg";
import Muffins3Src from "images/sour/Muffins3.jpg";
//import Babka1Src from "images/sour/babka1.jpg";
import Babka2Src from "images/sour/babka2.jpg";
import Babka3Src from "images/sour/babka3.jpg";
import Babka4Src from "images/sour/babka4.jpg";
import AppleCinnamonSourdoughBreadSrc from "images/sour/AppleCinnamonSourdoughBread.jpg";
//import PumpkinSpiceSourdoughBreadSrc from "images/sour/PumpkinSpiceSourdoughBread.jpg";
import SourdoughAppleCinnamonRollsSrc from "images/sour/SourdoughAppleCinnamonRolls.jpg";
//import SourdoughPumpkinPieRollsSrc from "images/sour/SourdoughPumpkinPieRolls.jpg";
import SourdoughBowlsSrc from "images/sour/sourdough_bowls.jpg";
//import SourdoughCranberryOrangeSrc from "images/sour/sourdough_cranberry_orange.jpg";
import SourdoughEnglishMuffinsSrc from "images/sour/sourdough_english_muffin.jpg";
import SourdoughChocolateSrc from "images/sour/sourdough_chocolate.jpg";
import SourdoughBlueberryLemonSrc from "images/sour/SourdoughBlueberryLemon.jpg";
//import SourdoughFlightSrc from "images/sour/flight.png";
//import SourdoughRedVelvetSrc from "images/sour/redvelvet.jpg";
import SourdoughHotHoneySrc from "images/sour/HotHoney.jpg";
import SourdoughJalapenoMuffinSrc from "images/sour/JalapenoMuffin.jpg";
//import SourdoughGnomeSrc from "images/sour/gnomes.png";

export const PRODUCTS = [
        { id:1,
          imageSrc:SourdoughOvalSrc,
          title: "Sourdough - Oval",
          content: "",
          price: 10.00,
          rating: "",
          reviews: "",
          url: "store",
          bread: true,          
          breakfast: false,
          dessert: false,          
          misc: false,
          inStock: 10,
          ratings: 5,
          ingredients: "Ingredients: Organic Unbleached Flour, Salt, Water",
          allergens: "Allergens: Wheat"
        },
        // {
        //   id:2,
        //   imageSrc:StarBreadSrc,
        //   title: "Sourdough - Star Bread",
        //   content: "",
        //   price: 25.00,
        //   rating: "",
        //   reviews: "",
        //   url: "store",
        //   bread: true,          
        //   breakfast: false,
        //   dessert: false,          
        //   misc: false,
        //   inStock: 10,
        //   ratings: 5,
        //   ingredients: "Ingredients: Organic Unbleached Flour, Salt, Water, Raspberries, White Chocolate, Powdered Sugar",
        //   allergens: "Allergens: Wheat"
        // },
        // {
        //   id:3,
        //   imageSrc:TreeBreadSrc,
        //   title: "Savory Sourdough - Christmas Tree",
        //   content: "",
        //   price: 25.00,
        //   rating: "",
        //   reviews: "",
        //   url: "store",
        //   bread: true,          
        //   breakfast: false,
        //   dessert: false,          
        //   misc: false,
        //   inStock: 10,
        //   ratings: 5,
        //   ingredients: "Ingredients: Organic Unbleached Flour, Salt, Milk, Egg, Sugar, Butter, Parmesan Cheese, Garlic, Herbs",
        //   allergens: "Allergens: Wheat"
        // }, 
        // {
        //   id:4,
        //   imageSrc:SourdoughFlightSrc,
        //   title: "Sourdough - 3 Flavor Flight",
        //   content: "",
        //   price: 15.00,
        //   rating: "",
        //   reviews: "",
        //   url: "store",
        //   bread: true,          
        //   breakfast: false,
        //   dessert: false,          
        //   misc: true,
        //   inStock: 10,
        //   ratings: 5,
        //   ingredients: "Choose 3: Double Chocolate, Cherry & Cream, Cranberry Orange, Jalapeno Cheddar, Rosemary & Garlic, Tomato Basil, Plain",
        //   allergens: "Allergens: Wheat"
        // },
        // {
        //   id:5,
        //   imageSrc:SourdoughGnomeSrc,
        //   title: "Christmas Gnome (order includes 1 gnome)",
        //   content: "",
        //   price: 15.00,
        //   rating: "",
        //   reviews: "",
        //   url: "store",
        //   bread: true,          
        //   breakfast: false,
        //   dessert: false,          
        //   misc: false,
        //   inStock: 9,
        //   ratings: 5,
        //   ingredients: "Ingredients: Organic Unbleached Flour, Salt, Water",
        //   allergens: "Allergens: Wheat"
        // },
        {
          id:6,
          imageSrc:SourdoughJalapenoCheddarSrc,
          title: "Sourdough - Jalapeno/Cheddar",
          content: "",
          price: 12.00,
          rating: "",
          reviews: "",
          url: "store",
          bread: true,          
          breakfast: false,
          dessert: false,          
          misc: false,
          inStock: 10,
          ratings: 5,
          ingredients: "Ingredients: Organic Unbleached Flour, Salt, Water, Cheddar Cheese, Jalapeno",
          allergens: "Allergens: Wheat, Milk"
        },
        {
          id:7,
          imageSrc:SourdoughMiniJalapenoCheddarSrc,
          title: "Sourdough - Jalapeno/Cheddar (Mini)",
          content: "",
          price: 7.00,
          rating: "",
          reviews: "",
          url: "store",
          bread: true,          
          breakfast: false,
          dessert: false,          
          misc: false,
          inStock: 10,
          ratings: 5,
          ingredients: "Ingredients: Organic Unbleached Flour, Salt, Water, Cheddar Cheese, Jalapeno",
          allergens: "Allergens: Wheat, Milk"
        },
        {
          id:8,
          imageSrc:SourdoughChocolateSrc,
          title: "Sourdough - Double Chocolate",
          content: "",
          price: 12.00,
          rating: "",
          reviews: "",
          url: "store",
          bread: true,          
          breakfast: false,
          dessert: false,          
          misc: false,
          inStock: 10,
          ratings: 5,
          ingredients: "Ingredients: Organic Unbleached Flour, Salt, Water, Chocolate Chip, White Chocolate, Cocoa Powder, Coconut Oil",
          allergens: "Allergens: Wheat"
        },        
        {
          id:9,
          imageSrc:SourdoughEnglishMuffinsSrc,
          title: "Sourdough English Muffins",
          content: "5ct",
          price: 7.00,
          rating: "",
          reviews: "",
          url: "store",
          bread: true,          
          breakfast: false,
          dessert: false,          
          misc: false,
          inStock: 10,
          ratings: 5,
          ingredients: "Ingredients Organic Unbleached Flour, Milk, Egg, Honey, Salt",
          allergens: "Allergens: Wheat, Milk, Egg"
        },
        {
          id:5,
          imageSrc:SourdoughJalapenoMuffinSrc,
          title: "Sourdough - Jalapeño Cheddar English Muffins",
          content: "5 ct",
          price: 8.00,
          rating: "",
          reviews: "",
          url: "store",
          bread: true,          
          breakfast: false,
          dessert: false,          
          misc: true,
          inStock: 10,
          ratings: 5,
          ingredients: "Ingredients: Organic unbleached flour, milk, honey, egg, salt, cheddar cheese, and jalapeño",
          allergens: "Allergens: Wheat, Milk, Egg"
        },
        // {
        //   id:10,
        //   imageSrc:SourdoughCranberryOrangeSrc,
        //   title: "Sourdough - Orange/Cranberry",
        //   content: "",
        //   price: 12.00,
        //   rating: "",
        //   reviews: "",
        //   url: "store",
        //   bread: true,          
        //   breakfast: false,
        //   dessert: false,          
        //   misc: false,
        //   inStock: 10,
        //   ratings: 5,
        //   ingredients: "Ingredients: Organic Unbleached Flour, Salt, Water, Sugar, Dried Cranberry, Orange Juice, Orange Zesty",
        //   allergens: "Allergens: Wheat"
        // },       
        {
          id:11,
          imageSrc:SourdoughBlueberryLemonSrc,
          title: "Sourdough - Blueberry Lemon",
          content: "",
          price: 12.00,
          rating: "",
          reviews: "",
          url: "store",
          bread: true,          
          breakfast: false,
          dessert: false,          
          misc: false,
          inStock: 10,
          ratings: 5,
          ingredients: "Ingredients: organic unbleached flour, fresh blueberries, sugar, salt, lemon zest",
          allergens: "Allergens: Wheat"
        },
        {
          id:12,
          imageSrc:SourdoughFocacciaSrc,
          title: "Sourdough - Garlic Parmesan Focaccia",
          content: "",
          price: 12.00,
          rating: "",
          reviews: "",
          url: "store",
          bread: true,          
          breakfast: false,
          dessert: false,          
          misc: false,
          inStock: 10,
          ratings: 5,
          ingredients: "Ingredients: Organic Unbleached Flour, Salt, Water, Olive Oil, Garlic, Parmesan Cheese",
          allergens: "Allergens: Wheat, Milk"
        }, 
        // {
        //   id:13,
        //   imageSrc:Babka1Src,
        //   title: "Sourdough Babka - Raspberry/White Chocolate",
        //   content: "",
        //   price: 17.00,
        //   rating: "",
        //   reviews: "",
        //   url: "store",
        //   bread: true,          
        //   breakfast: false,
        //   dessert: false,          
        //   misc: false,
        //   inStock: 10,
        //   ratings: 5,
        //   ingredients: "Ingredients: Organic Unbleached Flour, Milk, Eggs, Butter, Salt, Raspberries, White Chocolate",
        //   allergens: "Allergens: Wheat, Milk, Egg"
        // },        
        {
          id:14,
          imageSrc:Babka2Src,
          title: "Sourdough Babka - Chocolate",
          content: "",
          price: 17.00,
          rating: "",
          reviews: "",
          url: "store",
          bread: true,          
          breakfast: false,
          dessert: false,          
          misc: false,
          inStock: 10,
          ratings: 5,
          ingredients: "Ingredients: Organic Unbleached Flour, Milk, Eggs, Butter, Salt, Sugar, Chocolate",
          allergens: "Allergens: Wheat, Milk, Egg"
        },
        {
          id:15,
          imageSrc:Babka3Src,
          title: "Sourdough Babka - Cinnamon",
          content: "",
          price: 17.00,
          rating: "",
          reviews: "",
          url: "store",
          bread: true,          
          breakfast: false,
          dessert: false,          
          misc: false,
          inStock: 10,
          ratings: 5,
          ingredients: "Ingredients: Organic Unbleached Flour, Milk, Eggs, Butter, Sugar, Salt, Cinnamon",
          allergens: "Allergens: Wheat, Milk, Egg"
        },          
        {
          id:16,
          imageSrc:Babka4Src,
          title: "Sourdough Babka - Caramel Coconut",
          content: "",
          price: 17.00,
          rating: "",
          reviews: "",
          url: "store",
          bread: true,          
          breakfast: false,
          dessert: false,          
          misc: false,
          inStock: 10,
          ratings: 5,
          ingredients: "Ingredients: Organic Unbleached Flour, Milk, Eggs, Butter, Sugar, Salt, Caramel, Coconut",
          allergens: "Allergens: Wheat, Milk, Egg"
        },
          // {
          //   id:15,
          //   imageSrc:PandesalSrc,
          //   title: "Pandesal - Filipino Dinner Rolls",
          //   content: "12 ct",
          //   price: 10.00,
          //   rating: "",
          //   reviews: "",
          //   url: "store",
          //   bread: true,          
          //   breakfast: false,
          //   dessert: false,          
          //   misc: false,
          //   inStock: 10,
          //   ratings: 5,
          //   ingredients: "Ingredients: Organic Unbleached Flour, Water, Egg, Sugar, Salt, Vegetable Oil, Bread Crumbs",
          //   allergens: "Allergens: Wheat, Egg"
          // }, 
          {
            id:17,
            imageSrc:DinnerRollsSrc,
            title: "Sourdough Soft Dinner Rolls",
            content: "12 ct",
            price: 12.00,
            rating: "",
            reviews: "",
            url: "store",
            bread: true,          
            breakfast: false,
            dessert: false,          
            misc: false,
            inStock: 10,
            ratings: 5,
            ingredients: "Ingredients: Organic Unbleached Flour, Milk, Butter, Sugar, Salt",
            allergens: "Allergens: Wheat"
          }, 
          {
            id:18,
            imageSrc:SourdoughBowlsSrc,
            title: "Sourdough Bread Bowls",
            content: "3 ct",
            price: 14.00,
            rating: "",
            reviews: "",
            url: "store",
            bread: true,          
            breakfast: false,
            dessert: false,          
            misc: false,
            inStock: 10,
            ratings: 5,
            ingredients: "Ingredients: Organic Unbleached Flour, salt, water",
            allergens: "Allergens: Wheat"
          }, 
          {
            id:19,
            imageSrc:SourdoughUbeSrc,
            title: "Sourdough - Ube",
            content: "",
            price: 12.00,
            rating: "",
            reviews: "",
            url: "store",
            bread: true,          
            breakfast: false,
            dessert: false,          
            misc: false,
            inStock: 10,
            ratings: 5,
            ingredients: "Ingredients: Organic Unbleached Flour, Salt, Water, Ube Concentrate",
            allergens: "Allergens: Wheat"
          },
          {
            id:20,
            imageSrc:SourdoughMiniJalapenoCheddarSrc,
            title: "Sourdough - Rosemary",
            content: "",
            price: 11.00,
            rating: "",
            reviews: "",
            url: "store",
            bread: true,          
            breakfast: false,
            dessert: false,          
            misc: false,
            inStock: 10,
            ratings: 5,
            ingredients: "Ingredients: Organic Unbleached Flour, Salt, Water, Rosemary, Olive Oil",
            allergens: "Allergens: Wheat, Milk"
          },
          {
            id:21,
            imageSrc:SourdoughHotHoneySrc,
            title: "Cheesy Hot Honey Sourdough",
            content: "",
            price: 12.00,
            rating: "",
            reviews: "",
            url: "store",
            bread: true,          
            breakfast: false,
            dessert: false,          
            misc: true,
            inStock: 10,
            ratings: 5,
            ingredients: "Ingredients: Organic unbleached flour, salt, water, honey, cheese and pepper flakes",
            allergens: "Allergens: Wheat, Milk"
          }, 
          // {
          //   id:22,
          //   imageSrc:SourdoughRedVelvetSrc,
          //   title: "Red Velvet Cinnamon Roll (Pan of 6)",
          //   content: "6 ct",
          //   price: 20.00,
          //   rating: "",
          //   reviews: "",
          //   url: "store",
          //   bread: false,          
          //   breakfast: true,
          //   dessert: true,          
          //   misc: false,
          //   inStock: 10,
          //   ratings: 5,
          //   ingredients: "Ingredients: Organic unbleached flour, milk, butter, eggs, salt, sugar, cinnamon, red velvet emulsion, vanilla extract, cocoa powder, chocolate chips, cream cheese",
          //   allergens: "Allergens: Wheat, Milk, Egg"
          // },                 
          {
            id:23,
            imageSrc:MuffinsSrc,
            title: "Sourdough Muffins (Blueberry/Strawberry) 12ct",
            content: "12 ct",
            price: 18.00,
            rating: "",
            reviews: "",
            url: "store",
            bread: false,          
            breakfast: true,
            dessert: false,          
            misc: false,
            inStock: 10,
            ratings: 5,
            ingredients: "Ingredients: Organic Unbleached Flour, Sugar, Butter, Eggs, Sour Cream, Vanilla, Extract, Salt, Baking Powder, Baking Soda, Lemon Zest, Corn Starch, Fresh Blueberries/Strawberries",
            allergens: "Allergens: Wheat, Milk, Egg"
          },        
          {
            id:24,
            imageSrc:Muffins3Src,
            title: "Sourdough Muffins (Blueberry/Strawberry) 6ct",
            content: "6 ct",
            price: 10.00,
            rating: "",
            reviews: "",
            url: "store",
            bread: false,          
            breakfast: true,
            dessert: false,          
            misc: false,
            inStock: 10,
            ratings: 5,
            ingredients: "Ingredients: Organic Unbleached Flour, Sugar, Butter, Eggs, Sour Cream, Vanilla, Extract, Salt, Baking Powder, Baking Soda, Lemon Zest, Corn Starch, Fresh Blueberries/Strawberries",
            allergens: "Allergens: Wheat, Milk, Egg"
          },        
          {
            id:25,
            imageSrc:CinnamonRollsSrc,
            title: "Sourdough Cinnamon Rolls 6ct",
            content: "6 ct",
            price: 15.00,
            rating: "",
            reviews: "",
            url: "store",
            bread: false,          
            breakfast: true,
            dessert: false,          
            misc: false,
            inStock: 10,
            ratings: 5,
            ingredients: "Ingredients: Organic Unbleached Flour, Butter, Buttermilk, Honey, Salt, Brown Sugar, Cinnamon, Milk, Vanilla Extract",
            allergens: "Allergens: Wheat, Milk"
          },        {
            id:26,
            imageSrc:CinnamonRollsWildBerrySrc,
            title: "Sourdough Berry Sweet Rolls 6ct",
            content: "6 ct",
            price: 18.00,
            rating: "",
            reviews: "",
            url: "store",
            bread: false,          
            breakfast: true,
            dessert: false,          
            misc: false,
            inStock: 10,
            ratings: 5,
            ingredients: "Ingredients: Organic Unbleached Flour, Butter, Buttermilk, Honey, Salt, Brown Sugar, Cinnamon, Milk, Vanilla Extract, Strawberry, Blueberry",
            allergens: "Allergens: Wheat, Milk"
           },        
           {
            id:27,
            imageSrc:BrownButterCrumbleSrc,
            title: "Sourdough Brown Butter Crumble Rolls 6ct",
            content: "6 ct",
            price: 18.00,
            rating: "",
            reviews: "",
            url: "store",
            bread: false,          
            breakfast: true,
            dessert: false,          
            misc: false,
            inStock: 10,
            ratings: 5,
            ingredients: "Ingredients: Organic Unbleached Flour, Brown Butter, Buttermilk, Honey, Salt, Brown Sugar, Cinnamon, Milk, Vanilla Extract, Crumble",
            allergens: "Allergens: Wheat, Milk"
          },      
          // {
          //   id:27,
          //   imageSrc:SwedishCinnamonRollsSrc,
          //   title: "Sourdough Swedish Rolls",
          //   content: "10 ct",
          //   price: 20.00,
          //   rating: "",
          //   reviews: "",
          //   url: "store",
          //   bread: false,          
          //   breakfast: true,
          //   dessert: false,          
          //   misc: false,
          //   inStock: 10,
          //   ratings: 5,
          //   ingredients: "Ingredients: Organic Unbleached Flour, Butter, Buttermilk, Honey, Salt, Brown Sugar, Cinnamon, Milk, Vanilla Extract, Cardamon",
          //   allergens: "Allergens: Wheat, Milk"
          // },       
          {
          id:28,
          imageSrc:Scones5Src,
          title: "Sourdough Scones - Cranberry & White Chocolate 5ct",
          content: "5 ct",
          price: 10.00,
          rating: "",
          reviews: "",
          url: "store",
          bread: false,          
          breakfast: true,
          dessert: false,          
          misc: false,
          inStock: 10,
          ratings: 5,
          ingredients: "Ingredients: Organic Unbleached Flour, Sugar, Butter, Salt, White Chocolate, Dried Cranberries, Baking Powder, Egg, Heavy Cream, Vanilla Extract",
          allergens: "Allergens: Wheat, Milk, Egg"
        },        
        {
          id:29,
          imageSrc:SconesSrc,
          title: "Sourdough Scones - Cranberry & White Chocolate 10ct",
          content: "10 ct",
          price: 18.00,
          rating: "",
          reviews: "",
          url: "store",
          bread: false,          
          breakfast: true,
          dessert: false,          
          misc: false,
          inStock: 10,
          ratings: 5,
          ingredients: "Ingredients: Organic Unbleached Flour, Sugar, Butter, Salt, White Chocolate, Dried Cranberries, Baking Powder, Egg, Heavy Cream, Vanilla Extract",
          allergens: "Allergens: Wheat, Milk, Egg"
        },
        {
          id:30,
          imageSrc:SconesBlueberry5ctSrc,
          title: "Sourdough Scones - Blueberry with White Chocolate Drizzle 5ct",
          content: "5 ct",
          price: 10.00,
          rating: "",
          reviews: "",
          url: "store",
          bread: false,          
          breakfast: true,
          dessert: false,          
          misc: false,
          inStock: 10,
          ratings: 5,
          ingredients: "Ingredients: Organic Unbleached Flour, Sugar, Butter, Salt, White Chocolate, fresh blueberries, Baking Powder, Egg, Heavy Cream, Vanilla Extract",
          allergens: "Allergens: Wheat, Milk, Egg"
        },
        {
          id:31,
          imageSrc:SconesBlueberrySrc,
          title: "Sourdough Scones - Blueberry with White Chocolate Drizzle",
          content: "10 ct",
          price: 18.00,
          rating: "",
          reviews: "",
          url: "store",
          bread: false,          
          breakfast: true,
          dessert: false,          
          misc: false,
          inStock: 10,
          ratings: 5,
          ingredients: "Ingredients: Organic Unbleached Flour, Sugar, Butter, Salt, White Chocolate, fresh blueberries, Baking Powder, Egg, Heavy Cream, Vanilla Extract",
          allergens: "Allergens: Wheat, Milk, Egg"
        },       
        // {
        //   id:30,
        //   imageSrc:BrowniesSrc,
        //   title: "Brownies",
        //   content: "10 ct",
        //   price: 17.00,
        //   rating: "",
        //   reviews: "",
        //   url: "store",
        //   bread: false,          
        //   breakfast: false,
        //   dessert: true,          
        //   misc: false,
        //   inStock: 0,
        //   ratings: 5,
        //   ingredients: "Ingredients: ",
        //   allergens: "Allergens: "
        // },       
        {
          id:32,
          imageSrc:CookiesSrc,
          title: "Chocolate Chip/Butterscotch Cookies",
          content: "12 ct",
          price: 18.00,
          rating: "",
          reviews: "",
          url: "store",
          bread: false,          
          breakfast: false,
          dessert: true,          
          misc: false,
          inStock: 10,
          ratings: 5,
          ingredients: "Ingredients: Organic Unbleached Flour, Baking Soda, Corn Starch, Salt, Butter, Sugar, Eggs, Vanilla Extract, Butterscotch, Chocolate Chips",
          allergens: "Allergens: Wheat, Eggs"
        },       
        // {
        //   id:32,
        //   imageSrc:CheesecakeSrc,
        //   title: "Cheesecake",
        //   content: "",
        //   price: 50.00,
        //   rating: "",
        //   reviews: "",
        //   url: "store",
        //   bread: false,          
        //   breakfast: false,
        //   dessert: true,          
        //   misc: false,
        //   inStock: 0,
        //   ratings: 5,
        //   ingredients: "Ingredients: ",
        //   allergens: "Allergens: "
        // },       
        // {
        //   id:40,
        //   imageSrc:SauerkrautSrc,
        //   title: "Sauerkraut",
        //   content: "12 oz",
        //   price: 10.00,
        //   rating: "",
        //   reviews: "",
        //   url: "store",
        //   bread: false,          
        //   breakfast: false,
        //   dessert: false,          
        //   misc: false,
        //   inStock: 0,
        //   ratings: 5,
        //   ingredients: "Ingredients: Cabbage, Salt",
        //   allergens: "Allergens: "
        // },       
        // {
        //   id:41,
        //   imageSrc:KombuchaSrc,
        //   title: "Kombucha",
        //   content: "",
        //   price: 10.00,
        //   rating: "",
        //   reviews: "",
        //   url: "store",
        //   bread: false,          
        //   breakfast: false,
        //   dessert: false,          
        //   misc: false,
        //   inStock: 0,
        //   ratings: 5,
        //   ingredients: "Ingredients: ",
        //   allergens: "Allergens: "
        // },  
        {
          id:41,
          imageSrc:AppleCinnamonSourdoughBreadSrc,
          title: "Apple Cinnamon Sourdough Bread",
          content: "",
          price: 12.00,
          rating: "",
          reviews: "",
          url: "store",
          bread: true,          
          breakfast: false,
          dessert: false,          
          misc: false,
          inStock: 10,
          ratings: 5,
          ingredients: "Ingredients: Organic Unbleached Organic Unbleached Flour, Apple, Ground Cinnamon, Salt, Butter, Brown Sugar, Cornstarch, Water",
          allergens: "Allergens: Wheat"
        },
        // {
        //   id:42,
        //   imageSrc:PumpkinSpiceSourdoughBreadSrc,
        //   title: "Pumpkin Spice Sourdough Bread",
        //   content: "",
        //   price: 12.00,
        //   rating: "",
        //   reviews: "",
        //   url: "store",
        //   bread: true,          
        //   breakfast: false,
        //   dessert: false,          
        //   misc: false,
        //   inStock: 10,
        //   ratings: 5,
        //   ingredients: "Ingredients: Organic Unbleached Organic Unbleached Flour, Pumpkin Pie, Spice, Pumpkin Puree, Brown Sugar, Vanilla, Salt, Water",
        //   allergens: "Allergens: Wheat, Milk"
        // },      
        {
          id:43,
          imageSrc:SourdoughAppleCinnamonRollsSrc,
          title: "Apple Cinnamon Rolls with Caramel Drizzle 6ct",
          content: "6 ct",
          price: 18.00,
          rating: "",
          reviews: "",
          url: "store",
          bread: false,          
          breakfast: true,
          dessert: false,          
          misc: false,
          inStock: 10,
          ratings: 5,
          ingredients: "Ingredients: Organic Unbleached Organic Unbleached Flour, Milk, Eggs, Butter, Sugar, Ground Cinnamon, Apple, Salt, Caramel Sauce",
          allergens: "Allergens: Wheat, Milk, Egg"
        },      
        // {
        //   id:44,
        //   imageSrc:SourdoughPumpkinPieRollsSrc,
        //   title: "Sourdough Pumpkin Pie Rolls with Crumbles",
        //   content: "",
        //   price: 23.00,
        //   rating: "",
        //   reviews: "",
        //   url: "store",
        //   bread: false,          
        //   breakfast: true,
        //   dessert: false,          
        //   misc: false,
        //   inStock: 10,
        //   ratings: 5,
        //   ingredients: "Ingredients: Organic Unbleached Organic Unbleached Flour, Pumpkin Pie, Spice, Pumpkin Puree, Milk, Sugar, Eggs, Butter, Salt, Ground Cinnamon",
        //   allergens: "Allergens: Wheat, Milk, Egg"
        // },            
       ];
